import { render } from "./SellDetail.vue?vue&type=template&id=aa4038a2"
import script from "./SellDetail.vue?vue&type=script&lang=js"
export * from "./SellDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__